<template>
    <div class="container">
        <div class="col-lg-12 col-md-12 col-sm-12 mb-4 d-flex">
            <!-- rail-->
            <div v-if="this.railcard" class="mr-5 passes-card ">
                <div class="card passes-card ">
                    <div class="card-body mx-auto ">
                        <div class="row ">
                        <svg-icon aria-label="train icon" name="train" width="37.5" height="auto"></svg-icon>
                        </div>
                    </div>
                </div>
                <h3 class="text-center"> {{this.railcard}} </h3>
            </div>
            <!-- has Consession-->
            <div v-if=" this.hasConsession" class="mr-5 passes-card ">
                <div class="card passes-card ">
                    <div class="card-body mx-auto ">
                        <div class="row ">
                        <svg-icon aria-label="train icon" name="train" width="37.5" height="auto"></svg-icon>
                        </div>
                    </div>
                </div>
                <h3 class="text-center"> Consessionary Pass </h3>
            </div>

            <!-- has Car Access -->
            <div v-if="this.hasCar" class="mr-5 passes-card ">
                <div class="card passes-card ">
                    <div class="card-body mx-auto d-flex">
                        <div class="row ">
                        <svg-icon aria-label="car icon" name="car" width="37.5" height="auto"></svg-icon>
                        </div>
                    </div>
                </div>
                <h3 class="text-center"> Car Access </h3>
            </div>
            <!-- Has young Scot -->
            <div v-if="this.hasYoungScot" class="mr-5 passes-card">
                <div class="card passes-card  ">
                    <div class="card-body mx-auto d-flex">
                        <div class="row ">
                        <svg-icon aria-label="consession icon" name="Consession" width="37.5" height="auto"></svg-icon>
                        </div>
                    </div>
                </div>
                <h3 class="text-center"> YoungScot Card </h3>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'Account',
    props: ['hasCar', 'hasConsession', 'hasYoungScot', 'railcard'],
    components: {

    },
    data() {
        return {
        }
    },

}
</script>
<style lang="scss">
 .passes-card {
    min-height: 100px;
    min-width: 100px;
 }
</style>
